import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NitroParagraph, NitroModal } from 'nitro-components';
import * as authActions from '../../auth/actions';
import {refreshAccessToken} from '../../utils/auth0/access-token';
import styled from 'styled-components';
import auth0Logout from '../../utils/auth0/logout';

const messages = {
  WARNING: {
    modalIsOpen: true,
    isWarning: true,
    header: 'Your session is about to expire.',
    body:
      'Need more time? You can choose to stay signed in or to log out from the application.',
    okText: 'Stay Signed In',
    cancelText: 'Sign Out'
  },
  LOGOUT: {
    modalIsOpen: true,
    isWarning: false,
    header: 'Oops! Your session has expired.',
    body: 'Try logging in again',
    okText: 'Close',
    cancelText: ''
  }
};

const Container = styled.section`
  button:first-child {
    background-color: red;
    display:${props => (props.isWarning ? '' : 'none')}
`;

const initialState = {
  modalIsOpen: false,
  isWarning: false,
  header: null,
  body: null,
  okText: null,
  cancelText: null
};

class LoginTimeOut extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.showWarningDialog && this.props.showWarningDialog) {
      this.displayLogoutWarningDialog();
    } else if (!prevProps.showLogoutDialog && this.props.showLogoutDialog) {
      this.displayLogoutDialog();
    }
  }

  displayLogoutDialog = () => {
    this.logOut(true);
    this.setState({ ...messages.LOGOUT });
  };

  displayLogoutWarningDialog = () => {
    this.setState({ ...messages.WARNING });
  };

  signMeOut = () => {
    this.setState({ ...initialState });
    this.logOut();
    this.props.hideLogoutWarningDialog();
    this.props.hideLogoutDialog();
  }

  primaryAction = async () => {
    this.setState({ ...initialState });
    this.props.hideLogoutWarningDialog();
    this.props.hideLogoutDialog();

    if (this.state.isWarning) {
      await refreshAccessToken({ ignoreCache: true });
    }
    else {
      this.logOut();
    }
  };

  logOut = isSilent => {
    sessionStorage.clear();

    if (isSilent) {
      auth0Logout(isSilent);
      localStorage.removeItem('auth/token');
    }
    else {
      this.props.logout();
    }
  };

  render() {
    return (
      <Container isWarning={this.state.isWarning}>
        <section>
          <NitroModal
            close={this.signMeOut}
            cancelAction={this.signMeOut}
            isOpen={this.state.modalIsOpen}
            action={this.primaryAction}
            title={this.state.header}
            actionLabel={this.state.okText}
            cancelLabel={this.state.cancelText}
            actionMaxWidth={430}>
            <NitroParagraph>{this.state.body}</NitroParagraph>
          </NitroModal>
        </section>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  showWarningDialog: state.auth.showWarningDialog,
  showLogoutDialog: state.auth.showLogoutDialog
});

const mapDispatchToProps = dispatch => ({
  logout: bindActionCreators(authActions.logout, dispatch),
  hideLogoutWarningDialog: bindActionCreators(
    authActions.hideLogoutWarningDialog,
    dispatch
  ),
  hideLogoutDialog: bindActionCreators(authActions.hideLogoutDialog, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginTimeOut);



// WEBPACK FOOTER //
// ./src/features/login/LoginTimeOut.js